import {WEB3_GET_PROVIDER} from './providerActionsTypes';


const initialState = {
    providerState: null,
};

export default function getProviderReducer(state = initialState, action) {
    switch (action.type) {
        case WEB3_GET_PROVIDER:
            return {
                ...state,
                providerState: action.payload
            }
        default:
            return state;
    }
}